<div class="auction-hammer-component-wrapper">
  <div class="content-container d-flex align-items-center">
    <div class="icon">
      <mat-icon svgIcon="auction_hammer"></mat-icon>
    </div>
    <div class="hour"><b>Fim</b> {{ timeToOpen ? timeToOpen : '-' }}</div>
    <div class="text"><b>Pr. Teo.</b> {{ !priceTheory ? "-" : priceTheory | number }}</div>
    <div class="text"><b>Var. Teo.</b> {{ !varTheory ? "-" : varTheory }}%</div>
  </div>
</div>